import { render, staticRenderFns } from "./m-block-new-feature.vue?vue&type=template&id=420d23c6&scoped=true&lang=pug"
import script from "./m-block-new-feature.vue?vue&type=script&lang=js"
export * from "./m-block-new-feature.vue?vue&type=script&lang=js"
import style0 from "./m-block-new-feature.vue?vue&type=style&index=0&id=420d23c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d23c6",
  null
  
)

export default component.exports